<template>
  <div>
    <app-notification :title="'יש לנו כמה שאלות...'"
                  :text="'כדי להכין לך תזרים מדויק, נצטרך תשובות לכמה שאלות. זה יקח רק דקה.'"
                  :notification-buttons="[
                    {
                      title:'לדיוק התזרים!',
                      variant: 'primary',
                      action: openInvestigation,
                    },
                  ]"
                  :icon-type="'warning'"/>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';
import Segment from '../../../../../../../Segment';
import AppNotification from '../AppNotification.vue';
import ModalBus from '../../../../../../../event-bus/modal-bus';
import CashflowCategoryInvestigation from '../../investigations/cashflow-category/cashflow-category/CashflowCategoryInvestigation.vue';

export default {
  name: 'CashflowCategoryNotification',
  components: {
    AppNotification,
  },
  async created() {
    Segment.trackUserGot('CashflowInvestigationNotificationShown');
    this.startLoading(this.$options.name);
    await this.initCashflowCategory();
    this.doneLoading(this.$options.name);
  },
  computed: {
    ...mapState('cashflowCategoryActions', ['questions']),
  },
  methods: {
    ...mapActions('loader', ['startLoading', 'doneLoading']),
    ...mapActions('cashflowCategoryActions', ['initCashflowCategory']),
    ...mapActions('optimisticChange', ['applyOptimisticStack']),
    ...mapMutations('applicationState', ['setNotificationState']),
    openInvestigation() {
      ModalBus.$emit('open', {
        component: CashflowCategoryInvestigation,
        props: {
          onDoneInvestigation: this.onDoneInvestigation,
        },
      });
    },
    async onDoneInvestigation() {
      await this.setNotificationState(null);
      await this.applyOptimisticStack();
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
